<template>
  <div class="flex-shrink-0 ">
    <span
      class="inline-flex items-center justify-center h-10 w-10 rounded-full bg-vectric font-open-sans text-xl "
    >
      <span
        class="font-medium leading-none text-white uppercase"
        v-if="initial !== '?'"
        >{{ initial }}</span
      >
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 text-darkBlue"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        stroke-width="2"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
        />
      </svg>
    </span>
  </div>
</template>
<script>
export default {
  name: "Avatar",
  props: {
    userDisplay: {
      type: String,
      required: true
    }
  },
  computed: {
    initial() {
      if (!this.userDisplay || this.userDisplay.length === 0) {
        return "?";
      }
      return this.userDisplay.charAt(0);
    }
  }
};
</script>

<style scoped>
.bg-yellow {
  color: #ffc000;
}
</style>
